import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

// Initial State
const initialState = {}

// Action Creators
export function hydrateTemplatePageAttachment(attachment){
  const normalizedJson = normalize(attachment, Schemas.TEMPLATE_PAGE_ATTACHMENT)

  return (dispatch) => {
    dispatch(updateEntities(normalizedJson))
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    default:
      return state
  }
}
